import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { createAlert } from "../../redux/reducers/Alerts";
import queryString from "query-string";
import { trackPurchaseGA4, trackSignupGA4 } from "../../utils/utils";
import { ReduxState } from "src/redux";

type Props = {};

const CURRENCY_TO_USD = {
  GBP: 1.25,
  CAD: 0.74,
  AUD: 0.65,
  ZAR: 0.053,
  USD: 1,
};

export const QueryParamBanner: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { user } = useSelector((state: ReduxState) => state.User);

  const { error, success, value, currency, event, eventId } = queryString.parse(
    location.search
  );

  if (error) {
    dispatch(
      createAlert({
        type: "error",
        message: error,
        timeout: 0,
      })
    );
  } else if (success) {
    dispatch(
      createAlert({
        type: "success",
        message: success,
        timeout: 0,
      })
    );
  }

  if (event === "purchase" && currency && value) {
    // trackPurchaseGA4(value, currency);
    if (window && (window as any).lintrk) {
      (window as any).lintrk("track", { conversion_id: 10568572 });
    }
    if (window) {
      const currencyUpper = (currency as string).toUpperCase();
      const valueInUSD =
        parseFloat(value.toString()) *
        (CURRENCY_TO_USD[currencyUpper as keyof typeof CURRENCY_TO_USD] || 1);

      // Fire gtag purchase_frontend event with all relevant data
      if ((window as any).gtag) {
        (window as any).gtag("event", "purchase", {
          transaction_id: eventId,
          value: parseFloat(value.toString()),
          currency: currencyUpper,          
        });
      }

      if ((window as any).rdt) {
        (window as any).rdt("track", "Purchase", {
          value: valueInUSD,
          currency: "USD",
          itemCount: 1,
        });
      }
      if ((window as any).fbq) {
        (window as any).fbq(
          "track",
          "Purchase",
          { value: valueInUSD, currency: "USD" },
          { eventID: eventId }
        );
      }

      if (user?.email) {
        // ✅ Fire Google Ads Enhanced Conversion via GTM
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
          event: "purchase_complete", // Must match GTM Custom Event Trigger
          user_data: {
            email: user?.email, // raw email, not hashed
          },
          value: value,
          currency: currencyUpper,
          transaction_id: eventId,
          // transaction_id: orderId || undefined, // optional, helpful for deduplication
        });
      }
    }
  }

  return null;
};
export default QueryParamBanner;
